
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}

const _spaOnlyPageStub = { render: () => null };
import { default as createBH_MgxRb_lawHnKUsP5nv_9t_gurNW7oQnVs5iVCOgwMeta } from "/var/www/html/app/pages/dashboard/brands/create.vue?macro=true";
import { default as setupvcku1JWBTAb6KULEysQdOHR1bIm4ZNte_R1Ideizk90Meta } from "/var/www/html/app/pages/dashboard/brands/setup.vue?macro=true";
import { default as categoriesUJzHvrJG14qrzBubDfpp80j9xdoc_SPJB00FTzJa4jQMeta } from "/var/www/html/app/pages/dashboard/menus/categories.vue?macro=true";
import { default as createdO3Lwhb6ym5FrwRhAeWmBU_QZ_HIqQfYErc_kDZhhi4Meta } from "/var/www/html/app/pages/dashboard/menus/create.vue?macro=true";
import { default as itemsl0DHf5f4UTV6rEAK8sVmXbr_NWbMWcipseATu0xonm4Meta } from "/var/www/html/app/pages/dashboard/menus/items.vue?macro=true";
import { default as modifiersSYo0C13l8ZKTBWlLMKJqa53XDFuVo1_YbIlbutyvzEEMeta } from "/var/www/html/app/pages/dashboard/menus/modifiers.vue?macro=true";
import { default as createz_AKELZvgsveJTHcAn1J5pRrkC4zFq8Bn9WFKnIEYNEMeta } from "/var/www/html/app/pages/dashboard/stores/create.vue?macro=true";
import { default as setupbgpFiGd9Zm0QUqz9X5_dhdaLOBeK4hfNCy7cCJ9P0I0Meta } from "/var/www/html/app/pages/dashboard/stores/setup.vue?macro=true";
import { default as createoZUp8S_lsBRzpdgoiJcpvuziKxL7TFRhwm9Aj_C3SFAMeta } from "/var/www/html/app/pages/dashboard/users/create.vue?macro=true";
import { default as invitewRmaZGe8kTpmroael_NxWsRMiqH1NkYy8YjvJ4REB_sMeta } from "/var/www/html/app/pages/dashboard/users/invite.vue?macro=true";
import { default as editL3ItdL0G1u4erm7LiJkFyR9g78KBTXZIQHQRPcMuy2gMeta } from "/var/www/html/app/pages/dashboard/brands/[id]/edit.vue?macro=true";
import { default as edit_45itemsseWbLHHQyOKvSKSXTEL1XjE_EpOcoatPgebDN2FNqOMMeta } from "/var/www/html/app/pages/dashboard/orders/[id]/edit-items.vue?macro=true";
import { default as availability0Lm0b1crPZVA8IuchmXvUlHx0b6_taEtw2QQ31__n2oMeta } from "/var/www/html/app/pages/dashboard/stores/[id]/availability.vue?macro=true";
import { default as cuisinesCbPEuTxgcPwwB_ZtQgUxzgL2oL_GaZiiEEEEOcV3wccMeta } from "/var/www/html/app/pages/dashboard/stores/[id]/cuisines.vue?macro=true";
import { default as detailsYhZv5AMYUpuookeoaJiOACUNeQ3lPtzsQ9c7AwmZ_4UMeta } from "/var/www/html/app/pages/dashboard/stores/[id]/details.vue?macro=true";
import { default as hoursRQqi5B4Pu3pwmLa2rX5goXMpxv1_01k1dy7X2RsYlw8Meta } from "/var/www/html/app/pages/dashboard/stores/[id]/hours.vue?macro=true";
import { default as lead_45timeG7DM3_d5y1eiL0D6EQDRoRqYleu_7zdnBVOkPAs7_GEMeta } from "/var/www/html/app/pages/dashboard/stores/[id]/lead-time.vue?macro=true";
import { default as menuWaK1vkDPQbluZudf_f_zz1gMrGdr91ntIC2Hd7JPg6gMeta } from "/var/www/html/app/pages/dashboard/stores/[id]/menu.vue?macro=true";
import { default as payoutbRlzKsgzNJoj0SNPzVAPZEi3xgudrMCxCElm51mCBm0Meta } from "/var/www/html/app/pages/dashboard/stores/[id]/payout.vue?macro=true";
import { default as reviewsqtHpcnExqcWZUNyjeMPnWkC7OH7VGTvH8LwKWBIMp64Meta } from "/var/www/html/app/pages/dashboard/stores/[id]/reviews.vue?macro=true";
import { default as setupI64Ng5tFc8HfwzmvtV_0MVuq1mpAZur_vfcvqXwTCQgMeta } from "/var/www/html/app/pages/dashboard/stores/[id]/setup.vue?macro=true";
import { default as temporary_45closures117AKg4_OM4QqYVXT1BAcdOyupu7A_kQ_7ORkmq6_04Meta } from "/var/www/html/app/pages/dashboard/stores/[id]/temporary-closures.vue?macro=true";
import { default as editBdSMrQaO3nSnYLYZRyjspNHRH45jh1791XRSX2uprqkMeta } from "/var/www/html/app/pages/dashboard/users/[id]/edit.vue?macro=true";
import { default as indexwMfx5dCBoLA4nWwq3A0Q2L3YhCi7OLW6msiEviT4NcMMeta } from "/var/www/html/app/pages/dashboard/brands/[id]/index.vue?macro=true";
import { default as editp0TZ7v1Mj5k5GlDxpUHmJMUHylIQTSNrMiX9abnMLmEMeta } from "/var/www/html/app/pages/dashboard/menus/[id]/edit.vue?macro=true";
import { default as _91id_93C4xhKcrqMLyqW8WJ1OEDwsBwzQEEUNm5QV4oYKm_XMoMeta } from "/var/www/html/app/pages/dashboard/menus/[id].vue?macro=true";
import { default as indexLUK_Lge0Ylx4hfaGBuw_nj_134Uih31_Z_Tjsbft1GAMeta } from "/var/www/html/app/pages/dashboard/orders/[id]/index.vue?macro=true";
import { default as _91id_93XRNzvb47HukiOS_bMW1QoRxS1QgGGQ_SbN0_wRWvpTIMeta } from "/var/www/html/app/pages/dashboard/payments/[id].vue?macro=true";
import { default as _91id_93YnfBkxMxUSBtp0ENXNzdtI5FSmujRkWeU2f_8aTEnF8Meta } from "/var/www/html/app/pages/dashboard/payouts/[id].vue?macro=true";
import { default as indexdKiuB08gaLbRTD9wVjSMYJqPIuvsilFlaA8Gn9GELjIMeta } from "/var/www/html/app/pages/dashboard/stores/[id]/index.vue?macro=true";
import { default as indexI7UPaeufIY4ks91bx2EfsJVwLvWzsFisUVVAf9EoFbwMeta } from "/var/www/html/app/pages/dashboard/users/[id]/index.vue?macro=true";
import { default as _91token_93zLXpsM_0kJFQLPcI7dUqWwziOyy68WoEex7BMmNSzqIMeta } from "/var/www/html/app/pages/stores/reviews/[token].vue?macro=true";
import { default as indexW06ocO8_RD8nYtEVME_RwY9LcZeNp8Cjf9Mh1CgPBHwMeta } from "/var/www/html/app/pages/dashboard/brands/index.vue?macro=true";
import { default as indexl8nNWPDOwvVqIcabuHydH3go1ZhJR5SpSBJ9CFGiHNAMeta } from "/var/www/html/app/pages/dashboard/favorites/index.vue?macro=true";
import { default as indexzvC3lgMioASDtgrSoXbTEN1ccXt8fNTkUPqNkywJ1_kMeta } from "/var/www/html/app/pages/dashboard/menus/index.vue?macro=true";
import { default as indexCnTSwDq1aSanFZfShkOrcA6f6e9zGZ6jUoQttx3SDksMeta } from "/var/www/html/app/pages/dashboard/orders/index.vue?macro=true";
import { default as indexL9ehWX4K8jeIv42GIPD611MOjhyRmBGcl3aMOVRNeAgMeta } from "/var/www/html/app/pages/dashboard/payments/index.vue?macro=true";
import { default as indexO2hLgTel1lmSbWqK62_M4RrfkMrnkDhBJ5yhCE5_3_EMeta } from "/var/www/html/app/pages/dashboard/payouts/index.vue?macro=true";
import { default as reportsDpPZm_d_RtjLP9pTiTtBHaTnEjpwsK7UfcdWCVAb5fsMeta } from "/var/www/html/app/pages/dashboard/reports.vue?macro=true";
import { default as reviewsnZ6zxE0Lrm8JMXi4412SHHYdlpgmorhG0fiUfWRCGFcMeta } from "/var/www/html/app/pages/dashboard/reviews.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/var/www/html/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as onboarding_46client6B_uE3x5lIpGyjETpiAj_PvtI27aFKk3ekhPbRw25w4Meta } from "/var/www/html/app/pages/dashboard/settings/payout-accounts/onboarding.client.vue?macro=true";
import { default as _91id_936sBVGNU7p8A1Ws5ExtTxxfcosURr0Hv259_bpumH0E4Meta } from "/var/www/html/app/pages/dashboard/settings/payout-accounts/[id].vue?macro=true";
import { default as accountWlm6X4mELGhbErC8DujyRkRHVBmIZC8iZghhjwxjUwwMeta } from "/var/www/html/app/pages/dashboard/settings/account.vue?macro=true";
import { default as appearancemKytBmino03N0q_TB1oJG7jgUfRWjS5XnKwQnzlvmsgMeta } from "/var/www/html/app/pages/dashboard/settings/appearance.vue?macro=true";
import { default as billingSXdd01KhmVGyz5r8WGkxMP02fiPU6yvUZvPpZv77AycMeta } from "/var/www/html/app/pages/dashboard/settings/billing.vue?macro=true";
import { default as notificationsENa17mG3SFnDBcXUIpsByEsoHYzEIFxOzZe5MYkjB0cMeta } from "/var/www/html/app/pages/dashboard/settings/notifications.vue?macro=true";
import { default as indexYm_b5tLIECnppAFwb58vsj9RYhdpZ6UvpvjIh3D1dbEMeta } from "/var/www/html/app/pages/dashboard/settings/payout-accounts/index.vue?macro=true";
import { default as profileintyinh9HsgBy05tIucoNmVaa3sN6nUAvWIBNmqIsEoMeta } from "/var/www/html/app/pages/dashboard/settings/profile.vue?macro=true";
import { default as securityT6inR4FlbrT7_xE6QvZt3Wx7Q9jq4sqdGb0K40IiENQMeta } from "/var/www/html/app/pages/dashboard/settings/security.vue?macro=true";
import { default as indexmkWm4dazJueKDrgJnvPI1vr5WGf9Ca7pV0PTQgXej28Meta } from "/var/www/html/app/pages/dashboard/settings/index.vue?macro=true";
import { default as settingsPt2yXKxBRHn_NlMyvUz1tpUgkVvbzHRbKYQVeEKF4gMMeta } from "/var/www/html/app/pages/dashboard/settings.vue?macro=true";
import { default as indexieE_LX2USHpLvK66rzgI9emra_8lnaWCkx5sqWkIYUAMeta } from "/var/www/html/app/pages/dashboard/stores/index.vue?macro=true";
import { default as index0_y5kYGmQz9twvyrWnxsxOmbi6kLa3yXgvkhwwN_V9AMeta } from "/var/www/html/app/pages/dashboard/users/index.vue?macro=true";
import { default as organizerhHPW31gT2NaEDaeZv9TltGiPpyJEvbEHDZeCLG1fA4cMeta } from "/var/www/html/app/pages/register/organizer.vue?macro=true";
import { default as confirmation4E4ZxgnosGVN7zXXsrpQnkO8OqafQ0k_hsvtwU4JjZkMeta } from "/var/www/html/app/pages/order/[slug]/[id]/confirmation.vue?macro=true";
import { default as paymentNnEkro_Zsn3zhIoaD2Rx7CMZ7KkqP6jzB71NxJml4cUMeta } from "/var/www/html/app/pages/order/[slug]/[id]/payment.vue?macro=true";
import { default as review0OdZeT4VOB27hzxrzRNUpAcsNY05QkWjxPaaDZ7xSnAMeta } from "/var/www/html/app/pages/order/[slug]/[id]/review.vue?macro=true";
import { default as indexMeu_mL__mwVdeRwPJxq0nxoAvQLtGkh1Pk7AWIvkIRAMeta } from "/var/www/html/app/pages/order/[slug]/[id]/index.vue?macro=true";
import { default as _91slug_93U6e5q4SJMcnLhRmqYiiAYLVcLAi2Sat_jfxo34CLTRsMeta } from "/var/www/html/app/pages/brands/[slug].vue?macro=true";
import { default as _91slug_93LEwDcSWZEE73iJgOw7V41ITXIfudkBLumvW0GkIfEJwMeta } from "/var/www/html/app/pages/checkout/[slug].vue?macro=true";
import { default as _91slug_93Z167yO15_mqaKefbeeNVA0x96cSKrntCpS2OX_ZxU_sMeta } from "/var/www/html/app/pages/event/[slug].vue?macro=true";
import { default as _91order_number_93s4kMh8CvdkN8pRkSE2PnnYjxpvMyctIJ92sxuZLXP24Meta } from "/var/www/html/app/pages/lead/[order_number].vue?macro=true";
import { default as _91slug_93q2BUgO8xyvfjQvedxvSLgxxnHjNqcJikDljHB6JUN1YMeta } from "/var/www/html/app/pages/store/[slug].vue?macro=true";
import { default as _91_46_46_46slug_93lE7j3CULxyE_ui5wmb9SCbC87cet9H_kPytCJv7ck3kMeta } from "/var/www/html/app/pages/dashboard/[...slug].vue?macro=true";
import { default as about_45usTQRIvsZzBwe8CsJqqfzS_28ZBXW_q8WSpuw_fdScvpgMeta } from "/var/www/html/app/pages/about-us.vue?macro=true";
import { default as accept_45invitehyyEm9neydW6WBMqWOaoo5Q5U_Flllgb0l_8tH4tXq0Meta } from "/var/www/html/app/pages/accept-invite.vue?macro=true";
import { default as confirm_45email_7nKFF_eARsqFJzqDN_iXQ1_sWGbNhgRPPapUjiM3PYMeta } from "/var/www/html/app/pages/confirm-email.vue?macro=true";
import { default as contactwy9OqY2BJUOP6h1tZHikhbWBCxF_jDtf2YAzMVksaUEMeta } from "/var/www/html/app/pages/contact.vue?macro=true";
import { default as indexTRX0hvWc7YixFr4HGBXgHj4Y7ceMdmkgOe1n_GVaJkgMeta } from "/var/www/html/app/pages/dashboard/index.vue?macro=true";
import { default as eventsh2Tkon9kspUG9m7sX8RPmCSzxKyWZ_JLRvXCw2f_hEQMeta } from "/var/www/html/app/pages/events.vue?macro=true";
import { default as forgot_45password_Frwr25NvmsoQH0doYc5fdmi3wBKmxmHhMEkq6s2o7MMeta } from "/var/www/html/app/pages/forgot-password.vue?macro=true";
import { default as joinFPEllo04QypR6lRd77a2pPlZ0L17UFxIRv_lsnioJgIMeta } from "/var/www/html/app/pages/join.vue?macro=true";
import { default as loginwXSbd5bv3_0CNxov15g0PgNNcqxndcE3LH9clRnfVv0Meta } from "/var/www/html/app/pages/login.vue?macro=true";
import { default as partnerss_qc5q5pvg_7SHYACI4Xl0JG_W5ELgu_oV13hgP8F7QMeta } from "/var/www/html/app/pages/partners.vue?macro=true";
import { default as privacy_45policyVBWN_q6uGxJtAx5SnqAJJkHecEY4VuhairTIwEaz8NgMeta } from "/var/www/html/app/pages/privacy-policy.vue?macro=true";
import { default as indexxAYMcMcfE2P010Tf1FPkw_nad7vzAxiREkWh0wgBWzAMeta } from "/var/www/html/app/pages/register/index.vue?macro=true";
import { default as reset_45passwordkHO_hPe2zZxhaVL7x0_8rbdXDhA11nMdT3TEScHjqJIMeta } from "/var/www/html/app/pages/reset-password.vue?macro=true";
import { default as indext6Qp0WgF1bzOvL4kEE_LK_2yBY_s4JhUbbaWBsKF7nMMeta } from "/var/www/html/app/pages/search/index.vue?macro=true";
import { default as terms_45conditionspUkmQ2pd9fVL6LIdA9Z92Q5sIs4DeOH5ih2DzTxFWGMMeta } from "/var/www/html/app/pages/terms-conditions.vue?macro=true";
import { default as two_45factor_45verification__S09HiP8hh8NL9QAeyIFzKrxAEMNryFJByOL_XBVXwMeta } from "/var/www/html/app/pages/two-factor-verification.vue?macro=true";
import { default as verify_45emailef1W7b_kYniG1htaLDTNCO8biMCrBYhRLch2RVstvmYMeta } from "/var/www/html/app/pages/verify-email.vue?macro=true";
import { default as verify_45phoneH74lYGAkhCAqJhn5tMOA0ryxQ9cXUIOlJaos2ep7EbwMeta } from "/var/www/html/app/pages/verify-phone.vue?macro=true";
import { default as booking_45helpLijg993bFcxGz9I2LpRnMgcbMfjKRdHWH7EZmqgaIbwMeta } from "/var/www/html/app/pages/[eventSlug]/booking-help.vue?macro=true";
import { default as indexV5J561_D4Hg1Kl0TZWn4XI7i8KgIRgeKALbDnjPC8mMMeta } from "/var/www/html/app/pages/index.vue?macro=true";
import { default as component_45stub1ieq9ngBAdHBgz_spbP80jy_rDpu9r5e1KVm412_uaE } from "/var/www/html/node_modules/nuxt/dist/pages/runtime/component-stub.js";
import { default as component_45stub1ieq9ngBAdHBgz_spbP80jy_rDpu9r5e1KVm412_uaEMeta } from "/var/www/html/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
export default [
  {
    name: "dashboard-brands-create",
    path: "/dashboard/brands/create",
    meta: { ...(createBH_MgxRb_lawHnKUsP5nv_9t_gurNW7oQnVs5iVCOgwMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/brands/create.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-brands-setup",
    path: "/dashboard/brands/setup",
    meta: { ...(setupvcku1JWBTAb6KULEysQdOHR1bIm4ZNte_R1Ideizk90Meta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/brands/setup.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-menus-categories",
    path: "/dashboard/menus/categories",
    meta: { ...(categoriesUJzHvrJG14qrzBubDfpp80j9xdoc_SPJB00FTzJa4jQMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/menus/categories.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-menus-create",
    path: "/dashboard/menus/create",
    meta: { ...(createdO3Lwhb6ym5FrwRhAeWmBU_QZ_HIqQfYErc_kDZhhi4Meta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/menus/create.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-menus-items",
    path: "/dashboard/menus/items",
    meta: { ...(itemsl0DHf5f4UTV6rEAK8sVmXbr_NWbMWcipseATu0xonm4Meta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/menus/items.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-menus-modifiers",
    path: "/dashboard/menus/modifiers",
    meta: { ...(modifiersSYo0C13l8ZKTBWlLMKJqa53XDFuVo1_YbIlbutyvzEEMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/menus/modifiers.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-stores-create",
    path: "/dashboard/stores/create",
    meta: { ...(createz_AKELZvgsveJTHcAn1J5pRrkC4zFq8Bn9WFKnIEYNEMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/stores/create.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-stores-setup",
    path: "/dashboard/stores/setup",
    meta: { ...(setupbgpFiGd9Zm0QUqz9X5_dhdaLOBeK4hfNCy7cCJ9P0I0Meta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/stores/setup.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-users-create",
    path: "/dashboard/users/create",
    meta: { ...(createoZUp8S_lsBRzpdgoiJcpvuziKxL7TFRhwm9Aj_C3SFAMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/users/create.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-users-invite",
    path: "/dashboard/users/invite",
    meta: { ...(invitewRmaZGe8kTpmroael_NxWsRMiqH1NkYy8YjvJ4REB_sMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/users/invite.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-brands-id-edit",
    path: "/dashboard/brands/:id()/edit",
    meta: { ...(editL3ItdL0G1u4erm7LiJkFyR9g78KBTXZIQHQRPcMuy2gMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/brands/[id]/edit.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-orders-id-edit-items",
    path: "/dashboard/orders/:id()/edit-items",
    meta: { ...(edit_45itemsseWbLHHQyOKvSKSXTEL1XjE_EpOcoatPgebDN2FNqOMMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/orders/[id]/edit-items.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-stores-id-availability",
    path: "/dashboard/stores/:id()/availability",
    meta: { ...(availability0Lm0b1crPZVA8IuchmXvUlHx0b6_taEtw2QQ31__n2oMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/stores/[id]/availability.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-stores-id-cuisines",
    path: "/dashboard/stores/:id()/cuisines",
    meta: { ...(cuisinesCbPEuTxgcPwwB_ZtQgUxzgL2oL_GaZiiEEEEOcV3wccMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/stores/[id]/cuisines.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-stores-id-details",
    path: "/dashboard/stores/:id()/details",
    meta: { ...(detailsYhZv5AMYUpuookeoaJiOACUNeQ3lPtzsQ9c7AwmZ_4UMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/stores/[id]/details.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-stores-id-hours",
    path: "/dashboard/stores/:id()/hours",
    meta: { ...(hoursRQqi5B4Pu3pwmLa2rX5goXMpxv1_01k1dy7X2RsYlw8Meta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/stores/[id]/hours.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-stores-id-lead-time",
    path: "/dashboard/stores/:id()/lead-time",
    meta: { ...(lead_45timeG7DM3_d5y1eiL0D6EQDRoRqYleu_7zdnBVOkPAs7_GEMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/stores/[id]/lead-time.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-stores-id-menu",
    path: "/dashboard/stores/:id()/menu",
    meta: { ...(menuWaK1vkDPQbluZudf_f_zz1gMrGdr91ntIC2Hd7JPg6gMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/stores/[id]/menu.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-stores-id-payout",
    path: "/dashboard/stores/:id()/payout",
    meta: { ...(payoutbRlzKsgzNJoj0SNPzVAPZEi3xgudrMCxCElm51mCBm0Meta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/stores/[id]/payout.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-stores-id-reviews",
    path: "/dashboard/stores/:id()/reviews",
    meta: { ...(reviewsqtHpcnExqcWZUNyjeMPnWkC7OH7VGTvH8LwKWBIMp64Meta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/stores/[id]/reviews.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-stores-id-setup",
    path: "/dashboard/stores/:id()/setup",
    meta: { ...(setupI64Ng5tFc8HfwzmvtV_0MVuq1mpAZur_vfcvqXwTCQgMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/stores/[id]/setup.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-stores-id-temporary-closures",
    path: "/dashboard/stores/:id()/temporary-closures",
    meta: { ...(temporary_45closures117AKg4_OM4QqYVXT1BAcdOyupu7A_kQ_7ORkmq6_04Meta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/stores/[id]/temporary-closures.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-users-id-edit",
    path: "/dashboard/users/:id()/edit",
    meta: { ...(editBdSMrQaO3nSnYLYZRyjspNHRH45jh1791XRSX2uprqkMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/users/[id]/edit.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-brands-id",
    path: "/dashboard/brands/:id()",
    meta: { ...(indexwMfx5dCBoLA4nWwq3A0Q2L3YhCi7OLW6msiEviT4NcMMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/brands/[id]/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: _91id_93C4xhKcrqMLyqW8WJ1OEDwsBwzQEEUNm5QV4oYKm_XMoMeta?.name,
    path: "/dashboard/menus/:id()",
    meta: { ...(_91id_93C4xhKcrqMLyqW8WJ1OEDwsBwzQEEUNm5QV4oYKm_XMoMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/menus/[id].vue") : () => Promise.resolve(_spaOnlyPageStub),
    children: [
  {
    name: "dashboard-menus-id-categories",
    path: "categories",
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/menus/[id]/categories.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-menus-id-customizations",
    path: "customizations",
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/menus/[id]/customizations.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-menus-id-edit",
    path: "edit",
    meta: { ...(editp0TZ7v1Mj5k5GlDxpUHmJMUHylIQTSNrMiX9abnMLmEMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/menus/[id]/edit.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-menus-id-items",
    path: "items",
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/menus/[id]/items.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-menus-id-overview",
    path: "overview",
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/menus/[id]/overview.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-menus-id",
    path: "",
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/menus/[id]/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  }
]
  },
  {
    name: "dashboard-orders-id",
    path: "/dashboard/orders/:id()",
    meta: { ...(indexLUK_Lge0Ylx4hfaGBuw_nj_134Uih31_Z_Tjsbft1GAMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/orders/[id]/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-payments-id",
    path: "/dashboard/payments/:id()",
    meta: { ...(_91id_93XRNzvb47HukiOS_bMW1QoRxS1QgGGQ_SbN0_wRWvpTIMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/payments/[id].vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-payouts-id",
    path: "/dashboard/payouts/:id()",
    meta: { ...(_91id_93YnfBkxMxUSBtp0ENXNzdtI5FSmujRkWeU2f_8aTEnF8Meta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/payouts/[id].vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-stores-id",
    path: "/dashboard/stores/:id()",
    meta: { ...(indexdKiuB08gaLbRTD9wVjSMYJqPIuvsilFlaA8Gn9GELjIMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/stores/[id]/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-users-id",
    path: "/dashboard/users/:id()",
    meta: { ...(indexI7UPaeufIY4ks91bx2EfsJVwLvWzsFisUVVAf9EoFbwMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/users/[id]/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "stores-reviews-token",
    path: "/stores/reviews/:token()",
    meta: _91token_93zLXpsM_0kJFQLPcI7dUqWwziOyy68WoEex7BMmNSzqIMeta || {},
    component: () => import("/var/www/html/app/pages/stores/reviews/[token].vue")
  },
  {
    name: "dashboard-brands",
    path: "/dashboard/brands",
    meta: { ...(indexW06ocO8_RD8nYtEVME_RwY9LcZeNp8Cjf9Mh1CgPBHwMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/brands/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-favorites",
    path: "/dashboard/favorites",
    meta: { ...(indexl8nNWPDOwvVqIcabuHydH3go1ZhJR5SpSBJ9CFGiHNAMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/favorites/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-menus",
    path: "/dashboard/menus",
    meta: { ...(indexzvC3lgMioASDtgrSoXbTEN1ccXt8fNTkUPqNkywJ1_kMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/menus/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-orders",
    path: "/dashboard/orders",
    meta: { ...(indexCnTSwDq1aSanFZfShkOrcA6f6e9zGZ6jUoQttx3SDksMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/orders/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-payments",
    path: "/dashboard/payments",
    meta: { ...(indexL9ehWX4K8jeIv42GIPD611MOjhyRmBGcl3aMOVRNeAgMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/payments/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-payouts",
    path: "/dashboard/payouts",
    meta: { ...(indexO2hLgTel1lmSbWqK62_M4RrfkMrnkDhBJ5yhCE5_3_EMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/payouts/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-reports",
    path: "/dashboard/reports",
    meta: { ...(reportsDpPZm_d_RtjLP9pTiTtBHaTnEjpwsK7UfcdWCVAb5fsMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/reports.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-reviews",
    path: "/dashboard/reviews",
    meta: { ...(reviewsnZ6zxE0Lrm8JMXi4412SHHYdlpgmorhG0fiUfWRCGFcMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/reviews.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: settingsPt2yXKxBRHn_NlMyvUz1tpUgkVvbzHRbKYQVeEKF4gMMeta?.name,
    path: "/dashboard/settings",
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/settings.vue") : () => Promise.resolve(_spaOnlyPageStub),
    children: [
  {
    name: "dashboard-settings-payout-accounts-onboarding",
    path: "payout-accounts/onboarding",
    meta: { ...(onboarding_46client6B_uE3x5lIpGyjETpiAj_PvtI27aFKk3ekhPbRw25w4Meta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => createClientPage(import.meta.client ? () => import("/var/www/html/app/pages/dashboard/settings/payout-accounts/onboarding.client.vue") : undefined) : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-settings-payout-accounts-id",
    path: "payout-accounts/:id()",
    meta: { ...(_91id_936sBVGNU7p8A1Ws5ExtTxxfcosURr0Hv259_bpumH0E4Meta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/settings/payout-accounts/[id].vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-settings-account",
    path: "account",
    meta: { ...(accountWlm6X4mELGhbErC8DujyRkRHVBmIZC8iZghhjwxjUwwMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/settings/account.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-settings-appearance",
    path: "appearance",
    meta: { ...(appearancemKytBmino03N0q_TB1oJG7jgUfRWjS5XnKwQnzlvmsgMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/settings/appearance.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-settings-billing",
    path: "billing",
    meta: { ...(billingSXdd01KhmVGyz5r8WGkxMP02fiPU6yvUZvPpZv77AycMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/settings/billing.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-settings-notifications",
    path: "notifications",
    meta: { ...(notificationsENa17mG3SFnDBcXUIpsByEsoHYzEIFxOzZe5MYkjB0cMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/settings/notifications.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-settings-payout-accounts",
    path: "payout-accounts",
    meta: { ...(indexYm_b5tLIECnppAFwb58vsj9RYhdpZ6UvpvjIh3D1dbEMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/settings/payout-accounts/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-settings-profile",
    path: "profile",
    meta: { ...(profileintyinh9HsgBy05tIucoNmVaa3sN6nUAvWIBNmqIsEoMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/settings/profile.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-settings-security",
    path: "security",
    meta: { ...(securityT6inR4FlbrT7_xE6QvZt3Wx7Q9jq4sqdGb0K40IiENQMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/settings/security.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-settings",
    path: "",
    meta: { ...(indexmkWm4dazJueKDrgJnvPI1vr5WGf9Ca7pV0PTQgXej28Meta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/settings/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  }
]
  },
  {
    name: "dashboard-stores",
    path: "/dashboard/stores",
    meta: { ...(indexieE_LX2USHpLvK66rzgI9emra_8lnaWCkx5sqWkIYUAMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/stores/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "dashboard-users",
    path: "/dashboard/users",
    meta: { ...(index0_y5kYGmQz9twvyrWnxsxOmbi6kLa3yXgvkhwwN_V9AMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/users/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "event-eventStoreCardProjection",
    path: "/event/eventStoreCardProjection",
    component: () => import("/var/www/html/app/pages/event/eventStoreCardProjection.ts")
  },
  {
    name: "register-organizer",
    path: "/register/organizer",
    meta: organizerhHPW31gT2NaEDaeZv9TltGiPpyJEvbEHDZeCLG1fA4cMeta || {},
    component: () => import("/var/www/html/app/pages/register/organizer.vue")
  },
  {
    name: "order-slug-id-confirmation",
    path: "/order/:slug()/:id()/confirmation",
    meta: confirmation4E4ZxgnosGVN7zXXsrpQnkO8OqafQ0k_hsvtwU4JjZkMeta || {},
    component: import.meta.client ? () => import("/var/www/html/app/pages/order/[slug]/[id]/confirmation.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "order-slug-id-payment",
    path: "/order/:slug()/:id()/payment",
    meta: paymentNnEkro_Zsn3zhIoaD2Rx7CMZ7KkqP6jzB71NxJml4cUMeta || {},
    component: import.meta.client ? () => import("/var/www/html/app/pages/order/[slug]/[id]/payment.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "order-slug-id-review",
    path: "/order/:slug()/:id()/review",
    meta: review0OdZeT4VOB27hzxrzRNUpAcsNY05QkWjxPaaDZ7xSnAMeta || {},
    component: import.meta.client ? () => import("/var/www/html/app/pages/order/[slug]/[id]/review.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "order-slug-id",
    path: "/order/:slug()/:id()",
    meta: indexMeu_mL__mwVdeRwPJxq0nxoAvQLtGkh1Pk7AWIvkIRAMeta || {},
    component: import.meta.client ? () => import("/var/www/html/app/pages/order/[slug]/[id]/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "brands-slug",
    path: "/brands/:slug()",
    meta: _91slug_93U6e5q4SJMcnLhRmqYiiAYLVcLAi2Sat_jfxo34CLTRsMeta || {},
    component: () => import("/var/www/html/app/pages/brands/[slug].vue")
  },
  {
    name: "checkout-slug",
    path: "/checkout/:slug()",
    meta: _91slug_93LEwDcSWZEE73iJgOw7V41ITXIfudkBLumvW0GkIfEJwMeta || {},
    component: import.meta.client ? () => import("/var/www/html/app/pages/checkout/[slug].vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "event-slug",
    path: "/event/:slug()",
    meta: _91slug_93Z167yO15_mqaKefbeeNVA0x96cSKrntCpS2OX_ZxU_sMeta || {},
    component: () => import("/var/www/html/app/pages/event/[slug].vue")
  },
  {
    name: "lead-order_number",
    path: "/lead/:order_number()",
    meta: _91order_number_93s4kMh8CvdkN8pRkSE2PnnYjxpvMyctIJ92sxuZLXP24Meta || {},
    component: () => import("/var/www/html/app/pages/lead/[order_number].vue")
  },
  {
    name: "store-slug",
    path: "/store/:slug()",
    meta: _91slug_93q2BUgO8xyvfjQvedxvSLgxxnHjNqcJikDljHB6JUN1YMeta || {},
    component: () => import("/var/www/html/app/pages/store/[slug].vue")
  },
  {
    name: "dashboard-slug",
    path: "/dashboard/:slug(.*)*",
    meta: _91_46_46_46slug_93lE7j3CULxyE_ui5wmb9SCbC87cet9H_kPytCJv7ck3kMeta || {},
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/[...slug].vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "about-us",
    path: "/about-us",
    meta: about_45usTQRIvsZzBwe8CsJqqfzS_28ZBXW_q8WSpuw_fdScvpgMeta || {},
    component: () => import("/var/www/html/app/pages/about-us.vue")
  },
  {
    name: "accept-invite",
    path: "/accept-invite",
    meta: accept_45invitehyyEm9neydW6WBMqWOaoo5Q5U_Flllgb0l_8tH4tXq0Meta || {},
    component: () => import("/var/www/html/app/pages/accept-invite.vue")
  },
  {
    name: "confirm-email",
    path: "/confirm-email",
    meta: confirm_45email_7nKFF_eARsqFJzqDN_iXQ1_sWGbNhgRPPapUjiM3PYMeta || {},
    component: () => import("/var/www/html/app/pages/confirm-email.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contactwy9OqY2BJUOP6h1tZHikhbWBCxF_jDtf2YAzMVksaUEMeta || {},
    component: () => import("/var/www/html/app/pages/contact.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(indexTRX0hvWc7YixFr4HGBXgHj4Y7ceMdmkgOe1n_GVaJkgMeta || {}), ...{"middleware":"auth-redirect"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/dashboard/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "events",
    path: "/events",
    meta: eventsh2Tkon9kspUG9m7sX8RPmCSzxKyWZ_JLRvXCw2f_hEQMeta || {},
    component: () => import("/var/www/html/app/pages/events.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45password_Frwr25NvmsoQH0doYc5fdmi3wBKmxmHhMEkq6s2o7MMeta || {},
    component: () => import("/var/www/html/app/pages/forgot-password.vue")
  },
  {
    name: "join",
    path: "/join",
    meta: joinFPEllo04QypR6lRd77a2pPlZ0L17UFxIRv_lsnioJgIMeta || {},
    component: () => import("/var/www/html/app/pages/join.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginwXSbd5bv3_0CNxov15g0PgNNcqxndcE3LH9clRnfVv0Meta || {},
    component: () => import("/var/www/html/app/pages/login.vue")
  },
  {
    name: "partners",
    path: "/partners",
    meta: partnerss_qc5q5pvg_7SHYACI4Xl0JG_W5ELgu_oV13hgP8F7QMeta || {},
    component: () => import("/var/www/html/app/pages/partners.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyVBWN_q6uGxJtAx5SnqAJJkHecEY4VuhairTIwEaz8NgMeta || {},
    component: () => import("/var/www/html/app/pages/privacy-policy.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: indexxAYMcMcfE2P010Tf1FPkw_nad7vzAxiREkWh0wgBWzAMeta || {},
    component: () => import("/var/www/html/app/pages/register/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordkHO_hPe2zZxhaVL7x0_8rbdXDhA11nMdT3TEScHjqJIMeta || {},
    component: () => import("/var/www/html/app/pages/reset-password.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: indext6Qp0WgF1bzOvL4kEE_LK_2yBY_s4JhUbbaWBsKF7nMMeta || {},
    component: () => import("/var/www/html/app/pages/search/index.vue")
  },
  {
    name: "terms-conditions",
    path: "/terms-conditions",
    meta: terms_45conditionspUkmQ2pd9fVL6LIdA9Z92Q5sIs4DeOH5ih2DzTxFWGMMeta || {},
    component: () => import("/var/www/html/app/pages/terms-conditions.vue")
  },
  {
    name: "two-factor-verification",
    path: "/two-factor-verification",
    meta: two_45factor_45verification__S09HiP8hh8NL9QAeyIFzKrxAEMNryFJByOL_XBVXwMeta || {},
    component: () => import("/var/www/html/app/pages/two-factor-verification.vue")
  },
  {
    name: "verify-email",
    path: "/verify-email",
    meta: { ...(verify_45emailef1W7b_kYniG1htaLDTNCO8biMCrBYhRLch2RVstvmYMeta || {}), ...{"middleware":"redirect-verified-email"} },
    component: import.meta.client ? () => import("/var/www/html/app/pages/verify-email.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "verify-phone",
    path: "/verify-phone",
    meta: verify_45phoneH74lYGAkhCAqJhn5tMOA0ryxQ9cXUIOlJaos2ep7EbwMeta || {},
    component: import.meta.client ? () => import("/var/www/html/app/pages/verify-phone.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "eventSlug-booking-help",
    path: "/:eventSlug()/booking-help",
    meta: booking_45helpLijg993bFcxGz9I2LpRnMgcbMfjKRdHWH7EZmqgaIbwMeta || {},
    component: () => import("/var/www/html/app/pages/[eventSlug]/booking-help.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexV5J561_D4Hg1Kl0TZWn4XI7i8KgIRgeKALbDnjPC8mMMeta || {},
    component: () => import("/var/www/html/app/pages/index.vue")
  },
  {
    name: component_45stub1ieq9ngBAdHBgz_spbP80jy_rDpu9r5e1KVm412_uaEMeta?.name,
    path: "/signup",
    component: component_45stub1ieq9ngBAdHBgz_spbP80jy_rDpu9r5e1KVm412_uaE
  },
  {
    name: component_45stub1ieq9ngBAdHBgz_spbP80jy_rDpu9r5e1KVm412_uaEMeta?.name,
    path: "/auth/signup",
    component: component_45stub1ieq9ngBAdHBgz_spbP80jy_rDpu9r5e1KVm412_uaE
  }
]